export default __webpack_public_path__ + "static/media/meals.5d949a58.jpeg";